import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const pushover = defineConnector({
  identifier: "pushover",
  name: "Pushover",
  tagLine: "Notification delivery API",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.pushover\\.net/.*",
  auth: (app) =>
    queryAuth([
      { name: "token", value: app.secret.applicationToken },
      { name: "user", value: app.secret.userKey },
    ]),
  steps: [
    {
      title: "Collect the required credentials for Pushover",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://pushover.net/api](https://pushover.net/api) to create the credential values this API expects on each request.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "Application token",
          required: true,
          target: {
            kind: "secrets",
            field: "applicationToken",
          },
        },
        {
          kind: "input",
          label: "User key",
          required: true,
          target: {
            kind: "secrets",
            field: "userKey",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://api.pushover.net/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url:
        testUrl ?? (() => "https://api.pushover.net/1/users/validate.json")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
